import './App.css';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ImageView} from "./components/ImageView";
import {Search} from "./components/Search";
import { ThemeProvider } from "styled-components";
import theme from "./theme";
import {Competition} from "./components/Competition";
import {Hederstegn} from "./components/features/hederstegn/Hederstegn";
import {HederstegnPerson} from "./components/features/hederstegn/HederstegnPerson";
import {Championships} from "./components/features/championship/Championships";
import {Championship} from "./components/features/championship/Championship";
import {Statistics} from "./components/features/statistics/Statistics";
import {PersonStatistics} from "./components/features/statistics/PersonStatistics";
import {ClubStatistics} from "./components/features/statistics/ClubStatistics";
import {HederstegnStatistics} from "./components/features/statistics/HederstegnStatistics";
import {NSFFStatistics} from "./components/features/statistics/NSFFStatistics";

function App() {
  return <>
    <ThemeProvider theme={theme}>
    <BrowserRouter basename={"/resultater"}>
      <Routes>
        <Route path={"/mesterskap"} element={<Championships/>} />
        <Route path={"/mesterskap/:id"} element={<Championship />} />
        <Route path={"/hederstegn"} element={<Hederstegn/>} />
        <Route path={"/hederstegn/person/:id"} element={<HederstegnPerson/>} />
        <Route path={"/statistikk"} element={<Statistics/>} />
        <Route path={"/statistikk/personer"} element={<PersonStatistics/>} />
        <Route path={"/statistikk/klubber"} element={<ClubStatistics/>} />
        <Route path={"/statistikk/hederstegn"} element={<HederstegnStatistics/>} />
        <Route path={"/statistikk/nsff"} element={<NSFFStatistics/>} />
        <Route path={"/"} element={<Search/>} />
        <Route path="/image/:id" element={<ImageView />} />
        <Route path="/competition/:id" element={<Competition />} />
      </Routes>
    </BrowserRouter>
    </ThemeProvider>
  </>
}

export default App;
